import type { EpgGridTimelineAnchor } from "$src/core/models/epg";
import getPrimeTimeInstantMs from "$src/core/utils/epg/get-prime-time-instant-ms";

/** Aligns the program list: wall clock for today, prime time for other days. */
const getTimelineAnchorInstantMs = (
  timelineAnchor: EpgGridTimelineAnchor,
): number =>
  timelineAnchor.selectedDateOffset === 0
    ? Date.now()
    : getPrimeTimeInstantMs(
        timelineAnchor.dayStart,
        timelineAnchor.primeTime,
        timelineAnchor.timeZone,
      );

export default getTimelineAnchorInstantMs;
